export default "__VITE_ASSET__CqSBuUWF__"